export const iconFontAwesomeMoneyBtc = (
	<i className="fa-solid fa-btc"></i>
);
